// import request from '@/utils/request'
import request from '@/utils/ucenter_request'

// 获取优惠券信息 新 2021年10月14日改
export function getById(params) {
  return request({
    url: '/api/coupon/getById',
    method: 'get',
    params
  })
}

// 领取优惠券
export function receive(params) {
  return request({
    url: '/api/coupon/receivesq',
    method: 'post',
    data: params
  })
}
// 获取优惠卷列表
export function getlist(params) {
  return request({
    url: '/api/coupon/getList',
    method: 'get',
    params
  })
}
// 查看我的优惠券链接
export function getUrl(params) {
  return request({
    url: '/api/coupon/getUrl',
    method: 'post',
    data: params
  })
}


// 获取验证码
export function sendMobileCode(params) {
  return request({
    url: 'ucenter/login/sendMobileCode',
    method: 'get',
    params
  })
}
// 验证码登录(新)
export function loginByPhone(params) {
  return request({
    url: '/ucenter/login/loginByPhone',
    method: 'post',
    params
  })
}

export function searchProduct(params) {
  return request({
    url: '/personal/coupon/searchProduct',
    method: 'post',
    params
  })
}

export function getUserRankByuid(params) {
  return request({
    url: '/personal/myinfo/getUserRankByuid',
    method: 'post',
    params
  })
}

export function addCouponByUidRank(params) {
  return request({
    url: '/personal/coupon/addCouponByUidRank',
    method: 'post',
    params
  })
}
